export default [
    { //政策资讯列表
        path: '/policyManagement/message',
        name:'policyManagementMessage',
        meta: { title: '政策资讯列表'},
        component: () => import('../../views/policyManagement/message.vue')
    },
    { //政策资讯明细
        path: '/policyManagement/messageDetail',
        name:'policyManagementMessageDetail',
        meta: { title: '政策资讯明细'},
        component: () => import('../../views/policyManagement/messageDetail.vue')
    },
    { //政策申报列表
        path: '/policyManagement/declare',
        name:'policyManagementDeclare',
        meta: { title: '政策申报列表'},
        component: () => import('../../views/policyManagement/declare.vue')
    },
    { //政策申报明细
        path: '/policyManagement/declareDetail',
        name:'policyManagementDeclareDetail',
        meta: { title: '政策申报明细'},
        component: () => import('../../views/policyManagement/declareDetail.vue')
    },
]